import { Remote } from "comlink";

import { VM } from "./vm";

class BaseTerminal {
  public setVM(vm: VM | Remote<VM>) {
    throw new Error("setVM not implemented");
  }

  public write(data: string) {
    throw new Error("write not implemented");
  }

  public writeln(data: string) {
    throw new Error("writeln not implemented");
  }
}

class NodeTerminal {
  public setVM(vm: VM | Remote<VM>) {
    process.stdin.setRawMode(true);
    process.stdin.on("data", async (data: string) => {
      //@ts-ignore
      if (data[0] === 4) {
        await vm.destroy();
        process.exit();
      }
      await vm.sendSerialInputToTermClient(data);
    });
  }

  public write(data: string | Buffer | Array<number>) {
    if (typeof data !== "string" && !(data instanceof Buffer))
      data = Buffer.from(data);
    process.stdout.write(data);
  }

  public writeln(data: string) {
    process.stdout.write(data + "\n");
  }
}

export { BaseTerminal, NodeTerminal };
